import React from 'react';
import s from './Heading.styles';
const Heading = ({ children, semantic = 'h1', visual, ...otherProps }) => {
    return (React.createElement(s.Heading, { as: semantic, visual: visual, ...otherProps }, children));
};
export default Heading;
